import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import ConfirmAddress from '../pages/ConfirmAddress';
import ThankyouPage from '../pages/ThankyouPage';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/confirm-address" element={<ConfirmAddress />} />
      <Route path="/request-processed" element={<ThankyouPage />} />
    </Routes>
  );
};

export default AppRoutes;
